import React, { useState } from "react"
import { Link, useHistory } from "react-router-dom"
import { Button, Card, CardBody } from "reactstrap"
import PropTypes from "prop-types"
import InvoiceView from "../Bill/InvoiceView"
import { useDispatch } from "react-redux"
import { cleanBillError as onCleanBillError } from "store/bill/actions"

const BillErrorData = [
  { username: "Johnson Tan", billId: "BLSD211-7055", SGD: "120" },
  { username: "Yuves Low", billId: "BLSD211-3055", SGD: "7" },
]

const BillErrors = ({ data, carparks }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [openViewBill, setOpenViewBill] = useState(false)
  const [bill, setBill] = useState(null)
  const handleViewBill = bill => {
    console.log("bill", bill)
    setBill(bill)
    toggle()
  }
  const toggle = () => {
    setOpenViewBill(!openViewBill)
  }
  const handleViewMoreClick = () => {
    dispatch(onCleanBillError());
    history.push("/billingPage");
  }
  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <div className="d-flex">
            <div className="me-2">
              <h5 className="card-title mb-4">Bill Errors</h5>
            </div>
          </div>
          {/* Static data for View */}
          {/* {BillErrorData.map((billErrData, index) => (
            <dl className="row mb-0 font-size-12" key={`key_${index}`}>
              <dt className="col-sm-3 text-truncate">
                <Link className="text-dark" to="/">
                  {billErrData.username}
                </Link>
              </dt>
              <dd className="col-sm-4 text-truncate">{billErrData.billId}</dd>
              <dd className="col-sm-3">SGD {billErrData.SGD}</dd>
              <dd className="col-sm-2">
                <div className="d-inline-flex gap-3">
                  <a
                    className="text-info"
                    style={{ opacity: "5" }}
                    onClick={() => handleViewBill()}
                  >
                    <i
                      className="mdi mdi-file-eye font-size-16"
                      id="edittooltip1"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="View Bill Alert User"
                    ></i>
                  </a>
                  <a
                    className="text-warning"
                    href="/users"
                    style={{ opacity: "5" }}
                  >
                    <i
                      className="mdi mdi-file-alert font-size-16"
                      id="edittooltip"
                    ></i>
                  </a>
                </div>
              </dd>
            </dl>
          ))} */}
          {data ? (
            (data || []).map((el, i) => (
              <dl className="row mb-0 font-size-12" key={`key__${i}`}>
                <dt className="col-sm-3 text-truncate">
                  <Link className="text-dark" to="/">
                    {el?.userId?.name || "-"}
                  </Link>
                </dt>
                <dd className="col-sm-4 text-truncate">
                  {el?.billId?.billId || "-"}
                </dd>
                <dd className="col-sm-3">
                  SGD {(el?.billId?.billAmount?.$numberDecimal || 0).toString()}
                </dd>
                <dd className="col-sm-2">
                  <div className="d-inline-flex gap-3">
                    <a
                      className="text-info"
                      style={{ opacity: "5" }}
                      onClick={() => handleViewBill(el)}
                    >
                      <i
                        className="mdi mdi-file-eye font-size-16"
                        id="edittooltip1"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="View Bill Alert User"
                      ></i>
                    </a>
                    {/* <a
                    className="text-warning"
                    href="/users"
                    style={{ opacity: "5" }}
                  >
                    <i
                      className="mdi mdi-file-alert font-size-16"
                      id="edittooltip"
                    ></i>
                  </a> */}
                  </div>
                </dd>
              </dl>
            ))
          ) : (
            <p style={{ textAlign: "center" }}>There is no bill errors list</p>
          )}
          <div style={{ textAlign: "center" }}>
            <Button
                color="primary"
                className="font-16 btn-block btn btn-primary"
                onClick={()=>handleViewMoreClick()}
              >
                View More
                <i
                  className="mdi mdi-arrow-right me-1"
                  style={{ paddingLeft: "10px" }}
                />
            </Button>
          </div>
        </CardBody>
      </Card>
      {openViewBill && (
        <>
          <InvoiceView
            modal={openViewBill}
            toggle={toggle}
            bill={bill?.billId}
            gst={bill?.billId?.gst}//gst={parseInt(settingData?.paymentSettings?.gst)}
          />
        </>
      )}
    </React.Fragment>
  )
}
BillErrors.propTypes = {
  data: PropTypes.array,
  carparks: PropTypes.array,
}
export default BillErrors
